/* afzuigkapSpecialist.nl: grafisch menu (iconen, modelbeelden, mega-dropdown). Houdt de bestaande menu-markup en URL's intact. */
(function () {
  'use strict';
  var nav = document.querySelector('.main-nav');
  if (!nav || nav.getAttribute('data-wm')) return;
  nav.setAttribute('data-wm', '1');

  var THUMBS = window.WAVE_MENU_ART || {};
  var INFO = window.WAVE_MENU_INFO || {};
  var GROUPS = window.WAVE_MENU_GROUPS || {};
  var SVG = '<svg viewBox="0 0 32 32" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">';
  var ICONS = {
    'eiland-modellen': SVG + '<path d="M16 2v7"/><path d="M5 20c0-6 5-11 11-11s11 5 11 11z"/><path d="M8 25h16"/></svg>',
    'wand-modellen': SVG + '<path d="M3 5v22"/><rect x="8" y="9" width="21" height="8" rx="2"/><path d="M12 21h13M14 25h9"/></svg>',
    'inbouw-plafond-modellen': SVG + '<path d="M3 5h26"/><rect x="7" y="9" width="18" height="8" rx="1.5"/><path d="M11 13h10M13 22l-2 5M19 22l2 5M16 22v5"/></svg>',
    'frame-eilandmodellen': SVG + '<rect x="5" y="6" width="22" height="20" rx="2"/><rect x="10" y="11" width="12" height="10" rx="1"/></svg>',
    'inductiekookplaten': SVG + '<rect x="4" y="12" width="24" height="14" rx="2"/><circle cx="11" cy="19" r="3"/><circle cx="21" cy="19" r="3"/><path d="M13 3c-2 2 2 3 0 5M19 3c-2 2 2 3 0 5"/></svg>',
    'verlichting': SVG + '<path d="M16 3v4"/><path d="M8 16a8 8 0 1 1 16 0c0 3-2 4-2 7h-12c0-3-2-4-2-7z"/><path d="M12 27h8"/></svg>',
    'airone-afzuigkappen': SVG + '<path d="M4 11h15a3.5 3.5 0 1 0-3.5-3.5"/><path d="M4 17h21a3.5 3.5 0 1 1-3.5 3.5"/><path d="M4 23h11"/></svg>',
    'accessoires-onderdelen': SVG + '<path d="M4 6h24l-9 11v8l-6 3V17z"/></svg>',
    'wave-leder-kleuren': SVG + '<path d="M16 4c-7 0-12 4.5-12 10s4 8 8 8c2 0 3-1 3-2.5S14 17 16 17h4c4 0 8-1 8-5.5C28 7 22 4 16 4z"/><circle cx="10" cy="12" r="1.4"/><circle cx="16" cy="9" r="1.4"/><circle cx="22" cy="12" r="1.4"/></svg>'
  };
  var DESC = { 'OVAL': 'Zachte ovale lijnen', 'LINE': 'Strakke, lange lijn', 'SPHERE': 'Ronde bol', 'CIRCO': 'Ronde afzuigkap' };

  function key(href) {
    try {
      var p = new URL(href, location.origin).pathname.split('/').filter(Boolean);
      if (p[0] === 'collections' && p.length > 2) p = p.slice(0, 2);
      return p[p.length - 1] || '';
    } catch (e) { return ''; }
  }
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html) n.innerHTML = html;
    return n;
  }
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function thumb(src) {
    return '<span class="wm-thumb"><img src="' + esc(src) + '" alt="" loading="lazy" width="120" height="90"></span>';
  }
  function txt(name, sub) {
    return '<span class="wm-txt"><span class="wm-name">' + esc(name) + '</span>' + (sub ? '<span class="wm-sub">' + esc(sub) + '</span>' : '') + '</span>';
  }
  var mqDesk = window.matchMedia ? window.matchMedia('(min-width: 769px)') : { matches: true };

  /* klein paneel voor items zonder submenu (kookplaten, verlichting, Airone, kleuren) */
  function leafPanel(li, a, g) {
    var href = a.getAttribute('href');
    var h = '<div class="wm-mini__in' + (g.l ? ' wm-mini__in--links' : '') + '">';
    h += '<a class="wm-mini__feat" href="' + esc(href) + '">';
    if (g.i) h += '<span class="wm-mini__img"><img src="' + esc(g.i) + '" alt="" loading="lazy"></span>';
    if (g.sw) {
      h += '<span class="wm-mini__sw" aria-hidden="true">';
      g.sw.forEach(function (c) { h += '<i style="background:' + esc(c) + '"></i>'; });
      h += '</span>';
    }
    h += '<span class="wm-mini__t">' + esc(g.t) + '</span><span class="wm-mini__d">' + esc(g.d) + '</span><span class="wm-mini__cta">' + esc(g.c || 'Bekijk alles') + '</span></a>';
    if (g.l) {
      h += '<ul class="wm-mini__list">';
      g.l.forEach(function (it) {
        h += '<li><a class="wm-item wm-mini__item" href="' + esc(it.u) + '">' + (it.i ? thumb(it.i) : '') + txt(it.n, it.s) + '</a></li>';
      });
      h += '</ul>';
    }
    h += '</div>';
    var d = el('div', 'wm-mini', h);
    li.classList.add('wm-leaf');
    li.appendChild(d);
  }

  var tops = nav.querySelectorAll(':scope > li');
  Array.prototype.forEach.call(tops, function (li) {
    var a = li.querySelector('a.main-nav__item--primary') || li.querySelector(':scope > a');
    if (!a) return;
    var k = key(a.getAttribute('href'));
    li.setAttribute('data-wm-key', k);

    if (ICONS[k] && !a.querySelector('.wm-ico')) {
      var ic = el('span', 'wm-ico', ICONS[k]);
      ic.setAttribute('aria-hidden', 'true');
      a.insertBefore(ic, a.firstChild);
    }

    var g = GROUPS[k];
    var ul = li.querySelector('.child-nav--dropdown');
    if (!ul) {
      if (g && g.leaf) leafPanel(li, a, g);
      return;
    }
    var pick = g && g.pick ? g.pick : null;
    var minor = g && g.minor ? g.minor : [];
    var links = ul.querySelectorAll('a.child-nav__item:not(.main-nav__item-header)');
    var withArt = 0, total = 0;
    var byKey = {};

    Array.prototype.forEach.call(links, function (l) {
      var href = l.getAttribute('href') || '';
      var lk = key(href);
      var parent = l.closest('li');
      if (!parent || parent.querySelector('ul')) return;
      var isAll = lk === k && !pick;
      total += isAll ? 0 : 1;
      if (isAll) { parent.classList.add('wm-all'); return; }
      byKey[lk] = parent;
      var text = (l.textContent || '').replace(/\s+/g, ' ').trim();
      var m = text.match(/^(.*?)\s*\((.*)\)\s*$/);
      var info = INFO[lk] || {};
      var name = info.n || (m ? m[1] : text);
      var size = m ? m[2] : '';
      var d = DESC[name.split(' ')[0]] || '';
      var sub = info.s || [size, d].filter(Boolean).join(' · ');
      var art = THUMBS[lk];
      var html = '';
      if (art) { withArt += 1; html += thumb(art); }
      html += txt(name, sub);
      l.innerHTML = html;
      l.classList.add('wm-item');
      if (minor.indexOf(lk) > -1) parent.classList.add('wm-minor');
      if (pick && pick.indexOf(lk) > -1) parent.classList.add('wm-pick');
    });

    ul.classList.add(total && withArt / total >= 0.5 ? 'wm-cards' : 'wm-list');

    if (pick) {
      /* keuzepaneel (FRAME): twee grote keuzes, beugels klein eronder */
      ul.classList.add('wm-choice');
      pick.concat(minor).forEach(function (pk) { if (byKey[pk]) ul.appendChild(byKey[pk]); });
      var hd = ul.querySelector('a.main-nav__item-header');
      if (hd && g.h) { hd.textContent = g.h; hd.removeAttribute('href'); hd.setAttribute('role', 'heading'); hd.setAttribute('aria-level', '2'); }
      a.addEventListener('click', function (e) {
        if (!mqDesk.matches) return;
        e.preventDefault();
        var first = ul.querySelector('.wm-pick a');
        if (first && e.detail === 0) first.focus();
      });
    } else if (g && g.i) {
      ul.classList.add('wm-has-feature');
      var f = el('li', 'wm-feature');
      f.innerHTML = '<a class="wm-feature__a" href="' + esc(a.getAttribute('href')) + '"><span class="wm-feature__img"><img src="' + esc(g.i) + '" alt="" loading="lazy"></span>' +
        '<span class="wm-feature__t">' + esc(g.t) + '</span><span class="wm-feature__d">' + esc(g.d) + '</span><span class="wm-feature__cta">Bekijk alles</span></a>';
      var first = ul.querySelector('li:not(.md\\:hidden)');
      ul.insertBefore(f, first || ul.firstChild);
    }
  });

  /* paneel altijd binnen het scherm (max-hoogte + rijen voor de beeldkaart) */
  function fit(li) {
    var ul = li.querySelector('.child-nav--dropdown');
    if (!ul || !mqDesk.matches || !(ul.classList.contains('wm-cards') || ul.classList.contains('wm-list'))) return;
    requestAnimationFrame(function () {
      var top = ul.getBoundingClientRect().top;
      if (!(top > 0)) top = li.getBoundingClientRect().bottom;
      ul.style.setProperty('--wm-maxh', Math.max(260, Math.round(window.innerHeight - top - 16)) + 'px');
      var cols = getComputedStyle(ul).gridTemplateColumns.replace(/repeat\((\d+),\s*(minmax\([^)]*\)|[^)]+)\)/g, function (m, k) { return Array(+k + 1).join('x '); }).trim().split(/\s+/).length;
      var f = ul.querySelector('.wm-feature');
      if (f && getComputedStyle(f).display !== 'none') cols -= 1;
      var n = ul.querySelectorAll('.wm-item').length;
      ul.style.setProperty('--wm-rows', String(Math.max(1, Math.ceil(n / Math.max(1, cols)))));
    });
  }
  Array.prototype.forEach.call(tops, function (li) {
    li.addEventListener('mouseenter', function () { fit(li); });
    li.addEventListener('focusin', function () { fit(li); });
    fit(li);
  });
})();
